import PropTypes from 'prop-types';
import React from 'react';
import '../../LeadVettingPage/components/LeadVettingStyle.less';
import SignUpFlowSteps from './SignUpFlowSteps';

class SignUpForm extends React.Component {
  render() {
    const { fields, product, isLoading, onSubmit, updateFields, prepopulatedFields } = this.props;

    return (
      <SignUpFlowSteps
        submitSignUp={onSubmit}
        isLoading={isLoading}
        product={product}
        fields={fields}
        updateFields={updateFields}
        prepopulatedFields={prepopulatedFields}
      />
    );
  }
}

SignUpForm.propTypes = {
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
  product: PropTypes.string,
  fields: PropTypes.object,
  updateFields: PropTypes.func,
  prepopulatedFields: PropTypes.object,
};

export default SignUpForm;
